import { useQuery } from "@tanstack/react-query";
import type { SessionUser } from "@/lib/auth";
import { fetchMe } from "@/lib/auth";

export function useSession() {
  return useQuery<SessionUser | null>({
    queryKey: ["/api/me"],
    queryFn: fetchMe,
  });
}
